<!-- <router-outlet></router-outlet> -->
<!-- <app-job-list></app-job-list> -->
<!-- <div style="padding: 10px;"> -->
    <!-- <app-job-ex-list></app-job-ex-list> -->
<!-- </div> -->
<router-outlet *ngIf="isAuthenticated==true"></router-outlet>